import { get, post, del, put } from "../common/apiClient";

const PATH_QUESTION_BANK = "/question-bank";

const createQuestions = async (questions) => {
  return await post(PATH_QUESTION_BANK, { questions });
};

const getQuestions = async (pageNumber, limit = 10, searchQuery, tags) => {
  let query = `?page=${pageNumber}&limit=${limit}`;
  if (searchQuery) {
    query += `&search=${encodeURIComponent(searchQuery)}`;
  }
  if (tags) {
    query += `&tags=${encodeURIComponent(tags)}`;
  }
  return await get(PATH_QUESTION_BANK + query);
};

const getQuestionById = async (id) => {
  return await get(PATH_QUESTION_BANK + `/${id}`);
};

const updateQuestion = async (id, body) => {
  return await put(PATH_QUESTION_BANK + `/${id}`, body);
};

const deleteQuestion = async (id) => {
  return await del(PATH_QUESTION_BANK + `/${id}`);
};

const getAllTags = async () => {
  return await get(PATH_QUESTION_BANK + `/tags`);
};

const checkDuplicateQuestions = async (questions) => {
  return await post(PATH_QUESTION_BANK + `/check-duplicates`, { questions });
};

export {
  createQuestions,
  checkDuplicateQuestions,
  getQuestions,
  getQuestionById,
  updateQuestion,
  deleteQuestion,
  getAllTags,
};
